import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, MailX } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Common";
import EmailVerifyNotice from "@/components/EmailVerifyNotice";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, refresh } = useAuth();
  const [state, setState] = useState(null);
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    const token = params.get("token");
    if (!token) return setState({ ok: false, message: "Link di conferma non valido." });
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setState({ ok: true, message: data.message }); refresh(); })
      .catch((e) => setState({ ok: false, message: errMsg(e) }));
  }, [params, refresh]);

  if (!state) return <Loader text="Conferma dell'indirizzo email…" />;
  const Icon = state.ok ? MailCheck : MailX;
  return (
    <div className="space-y-5 px-6 py-10" data-testid="verify-email-page">
      <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#c9a96e] text-[#0d2517]"><Icon /></span>
      <h1 className="font-serif text-3xl font-semibold text-[#0d2517]">{state.ok ? "Email confermata" : "Conferma non riuscita"}</h1>
      <p className="text-sm text-[#2D3A30]" data-testid={state.ok ? "verify-email-success" : "verify-email-error"}>{state.message}</p>
      {!state.ok && <EmailVerifyNotice />}
      {user
        ? <Link to="/" className="btn-primary w-full" data-testid="verify-email-home">VAI ALLA HOME</Link>
        : <Link to="/accedi" className="btn-primary w-full" data-testid="verify-email-login">ACCEDI</Link>}
    </div>
  );
}
